// Back-in-stock / "Me prévenir" alert form.
//
// Progressive enhancement over a native {% form 'customer' %}: subscribes the
// visitor as an email-marketing customer (tagged for segmentation:
// alerte-ouverture / alerte-reassort + artiste:* + oeuvre:*), then shows an
// in-place confirmation without reloading the page.
//
// Degrades gracefully: if this script does not load, the form still posts
// natively and the visitor is still added to the customer list.
//
// One delegated listener handles every .product-alert__form on the page
// (product cards render many of them), so it works for cards and the product
// page alike.

const FORM_SELECTOR = '.product-alert__form';

async function subscribe(form) {
  const emailInput = form.querySelector('input[type="email"]');
  const tagsInput = form.querySelector('input[name="contact[tags]"]');

  const body = new FormData();
  body.append('form_type', 'customer');
  body.append('utf8', '✓');
  body.append('contact[email]', emailInput.value.trim());
  if (tagsInput) body.append('contact[tags]', tagsInput.value);

  // {% form 'customer' %} resolves a correct action (/contact); fall back to the
  // current page, which Shopify also accepts for form_type=customer.
  const action = form.getAttribute('action') || window.location.pathname;
  await fetch(action, {
    method: 'POST',
    body,
    headers: { Accept: 'text/html' },
    credentials: 'same-origin',
  });
}

async function handleSubmit(form) {
  const emailInput = form.querySelector('input[type="email"]');
  const errorEl = form.querySelector('[data-alert-error]');
  const successEl = form.querySelector('[data-alert-success]');
  const fields = form.querySelector('[data-alert-fields]');
  const submitBtn = form.querySelector('button[type="submit"]');

  if (errorEl) errorEl.hidden = true;

  if (!emailInput || !emailInput.value.trim() || !emailInput.checkValidity()) {
    if (errorEl) {
      errorEl.textContent = 'Merci de saisir une adresse email valide.';
      errorEl.hidden = false;
    }
    emailInput?.focus();
    return;
  }

  if (submitBtn) submitBtn.disabled = true;

  try {
    await subscribe(form);
    if (fields) fields.hidden = true;
    if (successEl) {
      successEl.hidden = false;
      successEl.focus?.();
    }
  } catch (e) {
    if (submitBtn) submitBtn.disabled = false;
    if (errorEl) {
      errorEl.textContent = 'Une erreur est survenue. Merci de réessayer.';
      errorEl.hidden = false;
    }
    console.warn('[product-alert] subscription failed', e);
  }
}

if (!window.__vangartProductAlertBound) {
  window.__vangartProductAlertBound = true;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;
    event.preventDefault();
    handleSubmit(form);
  });
}
